import React from "react";

const AboutHistorySection = ({ data }) => (

    <section className="about-section about-section-dark">

        <div className="about-container">

            <div className="story-grid">

                <div>

                    <div className="about-eyebrow">
                        {data.eyebrow}
                    </div>

                    <h2 className="about-title">
                        {data.title}
                        <span>{data.highlight}</span>
                    </h2>

                </div>

                <div className="story-box">

                    {(data.paragraphs || []).map(
                        (paragraph, i) => (
                            <p key={i}>
                                {paragraph}
                            </p>
                        )
                    )}

                </div>

            </div>

        </div>

    </section>
);

export default AboutHistorySection;